import type { VariantProps } from 'class-variance-authority'
import { cva } from 'class-variance-authority'
import type { ComponentProps, FC } from 'react'

import { cn } from '@/util/cn'

const badgeVariants = cva(
  'inline-flex items-center justify-center px-2 py-1 pb-1.5 text-center text-xs font-bold tabular-nums leading-tight md:text-sm',
  {
    variants: {
      variant: {
        kit: 'rounded-sm bg-rsf-green-badge text-black',
        usage: 'rounded-full bg-rsf-purple-light px-4 py-2 tracking-widest text-rsf-grey-blue',
        popup: 'rounded-full text-rsf-white',
      },
    },
    defaultVariants: {
      variant: 'kit',
    },
  },

)

type BadgeProps = VariantProps<typeof badgeVariants> & ComponentProps<'div'>

const Badge: FC<BadgeProps> = ({ children, className, variant, ...props }) => (
  <div
    className={cn(
      badgeVariants({ variant }),
      className,
    )}
    {...props}
  >
    {children}
  </div>
)

export default Badge
